import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8495 8.71104C13.1424 8.41815 13.6172 8.41815 13.9101 8.71104L15.9791 10.78C16.0985 10.8994 16.1692 11.0489 16.1913 11.2041C16.2011 11.273 16.2013 11.3431 16.1919 11.412C16.1862 11.4543 16.1769 11.4954 16.1645 11.5351C16.1295 11.6469 16.0677 11.7521 15.9791 11.8407L13.9101 13.9096C13.6172 14.2025 13.1424 14.2025 12.8495 13.9096C12.5566 13.6167 12.5566 13.1419 12.8495 12.849L13.6381 12.0603H10.6211C10.2713 12.0603 9.93584 12.1993 9.68849 12.4467C9.44114 12.694 9.30217 13.0295 9.30217 13.3793V14.069C9.30217 14.4832 8.96639 14.819 8.55217 14.819C8.13796 14.819 7.80217 14.4832 7.80217 14.069V13.3793C7.80217 12.6317 8.09917 11.9147 8.62783 11.386C9.15649 10.8573 9.8735 10.5603 10.6211 10.5603H13.6381L12.8495 9.7717C12.5566 9.47881 12.5566 9.00394 12.8495 8.71104Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.9578 13.018C1.39558 12.4557 1.39558 11.5442 1.9578 10.982L10.9825 1.95731C11.5447 1.39509 12.4562 1.39509 13.0185 1.95731L22.0431 10.982C22.6054 11.5442 22.6054 12.4557 22.0431 13.018L13.0185 22.0427C12.4562 22.6049 11.5447 22.6049 10.9825 22.0427L1.9578 13.018ZM3.06113 12L12.0005 20.9393L20.9398 12L12.0005 3.06064L3.06113 12Z"
        fill={colorValue}
      />
    </svg>
  );
};
